<template>
  <div class="ui-alert" :class="alertClass" @click="handleClick" :href="href" :to="to" :color="color">
    <div class="ui-alert-content">
      <ui-icon class="ui-alert-icon" :name="typeicon" :color="color" :size="20" />
      <span v-html="content"></span>
      <div class="ui-alert-append">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UiListItem",
  props: {
    // Naam van het icoon dat je wilt weergeven (optie voor ui-icon)
    icon: {
      type: String,
      default: "",
    },
    // Kleur voor het icoon
    color: {
      type: String,
      default: "",
    },
    // Titel voor de lijstitem
    content: {
      type: String,
      default: "",
    },

    // URL voor de link
    href: {
      type: String,
      default: "",
    },

    // Vue Router link (voor single page apps)
    to: {
      type: [String, Object],
      default: "",
    },
    variant: {
      type: String,
      default: "tonal", // Standaard waarde voor variant
    },
    type: {
      type: String,
      default: "info", // Standaard waarde voor type
    },
  },

  computed: {
    alertClass() {
      return [
        "ui-alert", // Basis class
        `ui-alert-${this.variant}`, // Dynamisch voor variant zoals ui-alert-tonal
        `ui-alert-${this.type}`, // Dynamisch voor type zoals ui-alert-info
      ];
    },

    typeicon() {
      const iconMap = {
        info: "info",
        success: "badge-check",
        warning: "octagon-alert",
        error: "triangle-alert",
      };
      return iconMap[this.type]; // Prioriteer custom icon prop
    },
  },

  watch: {
    // Bijwerken van de data wanneer de prop verandert
    data(newValue) {
      this.localdata = newValue;
    },
  },

  methods: {
    // Methode voor het afhandelen van de klikactie
    handleClick() {
      if (this.to) {
        // Als 'to' prop is opgegeven, wordt er naar de route genavigeerd
        this.$router.push(this.to);
      } else if (this.href) {
        // Als 'href' is opgegeven, wordt de gebruiker doorgestuurd naar de URL
        window.location.href = this.href;
      }
    },
  },
};
</script>
